<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template>
  <div class="legal-page">
    <section class="legal-card">
      <h1>Datenschutzerklaerung</h1>

      <h2>1. Datenschutz auf einen Blick</h2>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten
        personenbezogene Daten ausschliesslich auf Grundlage der gesetzlichen
        Bestimmungen, insbesondere der DSGVO und des BDSG.
      </p>

      <h2>2. Verantwortlicher</h2>
      <p>
        KFZ Musterwerkstatt<br />
        Vertreten durch: Max Mustermann<br />
        Musterstraße 12<br />
        12345 Musterstadt<br />
        E-Mail: info@musterwerkstatt.example
      </p>

      <h2>3. Hosting</h2>
      <p>
        Diese Website wird bei der IONOS SE, Elgendorfer Strasse 57, 56410
        Montabaur, Deutschland, betrieben. Die Verarbeitung erfolgt auf Servern
        innerhalb der Europaeischen Union. Mit dem Hosting-Anbieter besteht ein
        Vertrag zur Auftragsverarbeitung gemaess Art. 28 DSGVO.
      </p>

      <h2>4. Erhebung und Verarbeitung personenbezogener Daten</h2>

      <h3>a) Kontaktformular</h3>
      <p>
        Wenn Sie uns per Kontaktformular kontaktieren, verarbeiten wir Ihre
        Angaben aus dem Formular inklusive Ihrer Kontaktdaten zur Bearbeitung der
        Anfrage und fuer moegliche Anschlussfragen.
      </p>
      <ul>
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Nachricht</li>
      </ul>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO oder unser berechtigtes
        Interesse gemaess Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h3>b) Terminbuchung</h3>
      <p>
        Wenn Sie ueber unsere Website einen Werkstatttermin anfragen oder buchen,
        verarbeiten wir die Daten, die fuer die Planung und Durchfuehrung des
        Termins sowie fuer Rueckfragen und Terminbestaetigungen erforderlich sind.
      </p>
      <ul>
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Telefonnummer</li>
        <li>Kennzeichen</li>
        <li>Ausgewaehlte Leistungen</li>
        <li>Gewuenschtes Datum und Uhrzeit</li>
        <li>Bestaetigung der Kenntnisnahme dieser Datenschutzerklaerung</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt zur Vertragsanbahnung und Vertragsdurchfuehrung
        gemaess Art. 6 Abs. 1 lit. b DSGVO. Die Dokumentation der
        Datenschutzbestaetigung erfolgt auf Grundlage unseres berechtigten
        Interesses an einer nachvollziehbaren Bearbeitung der Anfrage gemaess
        Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h3>c) Automatisierte Terminverarbeitung mit n8n</h3>
      <p>
        Zur internen Organisation koennen Terminanfragen automatisiert verarbeitet
        werden. Hierfuer kann eine Automatisierungssoftware wie n8n eingesetzt
        werden, um nach erfolgreicher Buchung interne Benachrichtigungen
        auszuloesen, Kalendertermine anzulegen oder Rueckmeldungen an Kunden
        vorzubereiten.
      </p>
      <p>
        An diese Automatisierung werden nur die fuer die Terminbearbeitung
        erforderlichen Daten uebermittelt, insbesondere Name, Kontaktdaten,
        Kennzeichen, gewaehlte Leistungen sowie Datum und Uhrzeit des Termins.
        Die Uebermittlung erfolgt serverseitig aus unserem Backend und nicht
        direkt aus dem Browser des Nutzers.
      </p>
      <p>
        Wird n8n auf eigener Infrastruktur betrieben, erfolgt die Verarbeitung in
        unserem Verantwortungsbereich. Werden externe Dienste angebunden, zum
        Beispiel E-Mail-, Kalender- oder Hosting-Anbieter, erfolgt dies nur soweit
        erforderlich und auf Grundlage geeigneter Datenschutzvereinbarungen,
        insbesondere eines Vertrags zur Auftragsverarbeitung gemaess Art. 28 DSGVO,
        sofern gesetzlich erforderlich.
      </p>

      <h3>d) Bewerbungsformular</h3>
      <p>
        Wenn Sie sich ueber unser Bewerbungsformular bewerben, verarbeiten wir
        Ihre personenbezogenen Daten ausschliesslich zum Zweck der Durchfuehrung
        des Bewerbungsverfahrens.
      </p>
      <ul>
        <li>Name und Vorname</li>
        <li>E-Mail-Adresse</li>
        <li>Telefonnummer</li>
        <li>Gewuenschte Position</li>
        <li>Bewerbungsunterlagen, zum Beispiel Lebenslauf</li>
      </ul>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO sowie § 26 BDSG.
      </p>

      <h2>5. Speicherung und Loeschung der Daten</h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie dies zur
        Erfuellung der jeweiligen Zwecke erforderlich ist oder gesetzliche
        Aufbewahrungspflichten bestehen.
      </p>
      <ul>
        <li>Kontaktanfragen: bis zur abschliessenden Bearbeitung</li>
        <li>Termindaten: fuer die Organisation, Durchfuehrung und Nachbereitung des Termins</li>
        <li>Automatisierungsprotokolle: nur solange dies fuer Fehleranalyse und Nachvollziehbarkeit erforderlich ist</li>
        <li>Bewerbungen: maximal 6 Monate nach Abschluss des Verfahrens</li>
      </ul>

      <h2>6. Weitergabe von Daten</h2>
      <p>
        Eine Weitergabe personenbezogener Daten an Dritte erfolgt nur, wenn dies
        zur Erfuellung vertraglicher Pflichten erforderlich ist, eine gesetzliche
        Verpflichtung besteht oder Sie eingewilligt haben.
      </p>
      <p>
        Externe Dienstleister wie Hosting-, E-Mail-, Kalender- oder
        Automatisierungsanbieter werden nur im erforderlichen Umfang und auf
        Grundlage geeigneter Datenschutzvereinbarungen eingesetzt. Eine
        Uebermittlung in Drittstaaten erfolgt nur, wenn hierfuer eine geeignete
        Rechtsgrundlage besteht.
      </p>

      <h2>7. SSL- / TLS-Verschluesselung</h2>
      <p>
        Diese Website nutzt aus Sicherheitsgruenden eine SSL- bzw.
        TLS-Verschluesselung. Eine verschluesselte Verbindung erkennen Sie an
        "https://" in der Adresszeile.
      </p>

      <h2>8. Ihre Rechte</h2>
      <ul>
        <li>Auskunft ueber Ihre gespeicherten Daten</li>
        <li>Berichtigung oder Loeschung</li>
        <li>Einschraenkung der Verarbeitung</li>
        <li>Widerspruch gegen die Verarbeitung</li>
        <li>Datenuebertragbarkeit</li>
        <li>Beschwerderecht bei einer zustaendigen Datenschutzaufsichtsbehoerde</li>
      </ul>

      <h2>9. Widerruf Ihrer Einwilligung</h2>
      <p>
        Sie koennen eine bereits erteilte Einwilligung jederzeit widerrufen. Die
        Rechtmaessigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt davon
        unberuehrt.
      </p>

      <h2>10. Google Maps</h2>
      <p>
        Diese Website nutzt den Kartendienst Google Maps. Anbieter ist die Google
        Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Die
        Nutzung erfolgt im Interesse einer ansprechenden Darstellung unserer
        Online-Angebote und einer leichten Auffindbarkeit unseres Standorts auf
        Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
      </p>
      <p>
        Weitere Informationen finden Sie in der Datenschutzerklaerung von Google:
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">
          https://policies.google.com/privacy
        </a>
      </p>

      <h2>11. WhatsApp Kontakt</h2>
      <p>
        Fuer die Kontaktaufnahme bieten wir die Moeglichkeit, ueber WhatsApp
        Kontakt aufzunehmen. Anbieter ist die WhatsApp Ireland Limited, 4 Grand
        Canal Square, Grand Canal Harbour, Dublin 2, Irland.
      </p>
      <p>
        Wenn Sie ueber WhatsApp Kontakt mit uns aufnehmen, werden Daten wie Ihre
        Telefonnummer, Nachrichteninhalte und weitere Kommunikationsdaten
        verarbeitet. Die Nutzung erfolgt freiwillig auf Grundlage von Art. 6 Abs.
        1 lit. a DSGVO sowie Art. 6 Abs. 1 lit. f DSGVO.
      </p>
      <p>
        Weitere Informationen finden Sie unter:
        <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener">
          https://www.whatsapp.com/legal/privacy-policy-eea
        </a>
      </p>
    </section>
  </div>
</template>
